import React from 'react';

const AsyncPostsList = React.lazy(() => import('./ListContainer'));

export const PostsListPage = () => {
  return <AsyncPostsList />;
};
